import {
    PUSH_EXPLORE_LIST,
    CLEAR_EXPLORE_LIST,
    UPDATE_EXPLORE_LIST
} from "@/store/mutations.type"

const StateKey = 'exploreList'

export default {
    [CLEAR_EXPLORE_LIST](state) {
        state[StateKey] = []
        state[`${StateKey}Offset`] = 0
        state[`${StateKey}FetchCompleted`] = false
    },

    [PUSH_EXPLORE_LIST](state, items) {
        if (items.length) {
            items.forEach((item) => {
                if (item) state[StateKey].push(item)
            })
        }
        if (items.length === state[`${StateKey}Limit`]) {
            state[`${StateKey}Offset`] += state[`${StateKey}Limit`]
        } else {
            state[`${StateKey}FetchCompleted`] = true
        }
    },

    [UPDATE_EXPLORE_LIST](state, payload) {
        const item = state[StateKey].find(item => item.id === payload.itemId)
        if(item) Object.assign(item, payload.value)
    }
}